class CustomNav extends HTMLElement {
  connectedCallback() {
    this.dom = this.mapDom();
    this.bindDesktopMega();
    this.bindMobile();
  }

  mapDom() {
    return {
      body: document.body,
      // Desktop mega
      megaParents: Array.from(this.querySelectorAll('[data-mega="parent"]')),
      // Mobile
      toggle: this.querySelector('[data-nav="toggle"]') || null,
      iconOpen: this.querySelector('[data-nav="icon-open"]') || null,
      iconClose: this.querySelector('[data-nav="icon-close"]') || null,
      drawer: this.querySelector('#mobile-drawer') || null,
      overlay: this.querySelector('#mobile-overlay') || null,
      accordions: Array.from(this.querySelectorAll('[data-accordion="toggle"]'))
    };
  }

  // ----- Desktop mega-menu -----
  bindDesktopMega() {
    const { megaParents } = this.dom;
    megaParents.forEach((li) => {
      const toggle = li.querySelector('[data-mega="toggle"]');
      const panel  = li.querySelector('[data-mega="panel"]');
      const chevron = li.querySelector('[data-mega="chevron"]');
      if (!toggle || !panel) return;

      // Hover + focus with fade/slide
      const open = () => {
        toggle.setAttribute('aria-expanded', 'true');
        panel.classList.remove('invisible','opacity-0','pointer-events-none');
        panel.querySelector('div').classList.remove('translate-y-1');
        if (chevron) chevron.classList.add('rotate-180');
      };
      const close = () => {
        toggle.setAttribute('aria-expanded', 'false');
        panel.classList.add('opacity-0','pointer-events-none');
        // delay visibility to allow fade
        setTimeout(() => panel.classList.add('invisible'), 150);
        panel.querySelector('div').classList.add('translate-y-1');
        if (chevron) chevron.classList.remove('rotate-180');
      };

      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', close);
      toggle.addEventListener('focus', open);
      toggle.addEventListener('blur', () => setTimeout(close, 50));
      panel.addEventListener('mouseenter', open);
      panel.addEventListener('mouseleave', close);
    });
  }

  // ----- Mobile drawer -----
  bindMobile() {
    const { toggle, accordions } = this.dom;
    if (toggle) toggle.addEventListener('click', () => this.toggleDrawer());

    accordions.forEach(btn => btn.addEventListener('click', () => this.toggleAccordion(btn)));

    document.addEventListener('click', (e) => {
      const { drawer, overlay, toggle } = this.dom;
      if (!drawer || drawer.hasAttribute('hidden')) return;
      const inside = drawer.contains(e.target) || (toggle && toggle.contains(e.target));
      if (!inside) this.closeDrawer();
      if (overlay && e.target === overlay) this.closeDrawer();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeDrawer(); });
  }

  toggleDrawer() {
    const { drawer, overlay, iconOpen, iconClose, body, toggle } = this.dom;
    if (!drawer) return;

    const hidden = drawer.hasAttribute('hidden');
    if (hidden) {
      drawer.removeAttribute('hidden');
      requestAnimationFrame(() => { drawer.style.transform = 'translateX(0)'; });
      if (overlay) {
        overlay.removeAttribute('hidden');
        requestAnimationFrame(() => overlay.classList.remove('opacity-0','pointer-events-none'));
      }
      body.classList.add('overflow-hidden');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (iconOpen) iconOpen.classList.add('hidden');
      if (iconClose) iconClose.classList.remove('hidden');
    } else {
      this.closeDrawer();
    }
  }

  closeDrawer() {
    const { drawer, overlay, iconOpen, iconClose, body, toggle } = this.dom;
    if (!drawer || drawer.hasAttribute('hidden')) return;

    drawer.style.transform = 'translateX(100%)';
    drawer.addEventListener('transitionend', () => drawer.setAttribute('hidden',''), { once: true });

    if (overlay) {
      overlay.classList.add('opacity-0');
      overlay.addEventListener('transitionend', () => {
        overlay.classList.add('pointer-events-none');
        overlay.setAttribute('hidden','');
      }, { once: true });
    }

    body.classList.remove('overflow-hidden');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (iconOpen) iconOpen.classList.remove('hidden');
    if (iconClose) iconClose.classList.add('hidden');
  }

  toggleAccordion(btn) {
    const panel = this.querySelector('#' + btn.getAttribute('aria-controls'));
    if (!panel) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');

    const icon = btn.querySelector('svg');
    if (icon) icon.style.transform = expanded ? '' : 'rotate(180deg)';

    panel.style.gridTemplateRows = expanded ? '0fr' : '1fr';
  }
}

customElements.define('custom-nav', CustomNav);
